var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3486 25L18.6726 11.976H11.8966V9.16H21.8846V11.976L16.5826 25H13.3486Z",
    fill: "#2B65CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.75 39C24.1525 39 17 46.1525 17 47.75C17 46.1525 9.84751 39 8.25 39C9.84751 39 17 31.8475 17 30.25C17 31.8475 24.1525 39 25.75 39Z",
    fill: "#2B65CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.75 59C49.8745 59 37 71.8745 37 74.75C37 71.8745 24.1255 59 21.25 59C24.1255 59 37 46.1255 37 43.25C37 46.1255 49.8745 59 52.75 59Z",
    fill: "#2B65CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7D);
export default __webpack_public_path__ + "static/media/7d.f2b2d35218ec69568f7528337e8afb99.svg";
export { ForwardRef as ReactComponent };